import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, Transition as _Transition, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/image/ai/loading.png'


const _hoisted_1 = { class: "ai-st" }
const _hoisted_2 = { class: "lt primary-scroll" }
const _hoisted_3 = { style: {"padding":"30px"} }
const _hoisted_4 = { class: "lt-line" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "lt-line" }
const _hoisted_7 = { class: "lt-line" }
const _hoisted_8 = { class: "tags" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "lt-line" }
const _hoisted_11 = { class: "color-list" }
const _hoisted_12 = ["onClick", "title"]
const _hoisted_13 = { class: "lt-line" }
const _hoisted_14 = { class: "lt-line" }
const _hoisted_15 = { class: "orient" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = ["src"]
const _hoisted_18 = { style: {"text-align":"center","margin-top":"10px"} }
const _hoisted_19 = { class: "rt" }
const _hoisted_20 = { style: {"text-align":"center"} }
const _hoisted_21 = { class: "rt-box" }
const _hoisted_22 = {
  class: "swiper",
  id: "rt-swiper"
}
const _hoisted_23 = { class: "swiper-wrapper" }
const _hoisted_24 = ["src"]

import {nextTick, reactive, ref, watch} from "vue";
import {
  Input,
  Button as AButton,
  Slider as ASlider,
  Space as ASpace,
  InputNumber as AInputNumber, message,
  Modal as AModal
} from "ant-design-vue";
import service from "@/utils/axios";
import Swiper, {Keyboard, Pagination, Controller,} from 'swiper';
import 'swiper/swiper.min.css';
import 'swiper/modules/pagination/pagination.min.css';
import MaterialLibrary from "@/components/ai/MaterialLibrary.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'AIStyleTransfer',
  props: {
  type: {
    required: true,
    type: Number
  }
},
  setup(__props) {

Swiper.use([Keyboard, Pagination, Controller]);

const ATextArea = Input.TextArea;
const marks = {
  0: '0',
  10: '10%',
  20: '20%',
  30: '30%',
  40: '40%',
  50: '50%',
  60: '60%',
  70: '70%',
  80: '80%',
  90: '90%',
  100: '100%',
}

let timeout, swiperItem;

let props = __props


let dataRef = reactive({
  tags: [],
  colorList: [
    {color: '240,5,9', name: '红色', checked: false},
    {color: '252,239,41', name: '黄色', checked: false},
    {color: '153,70,100', name: '深绿', checked: false},
    {color: '35,141,214', name: '浅蓝', checked: false},
    {color: '84,214,78', name: '浅绿', checked: false},
    {color: '245,113,0', name: '橙色', checked: false},
    {color: '132,0,154', name: '紫色', checked: false},
    {color: '255,119,171', name: '粉色', checked: false},
    {color: '143,69,33', name: '咖啡色', checked: false},
    {color: '10,12,15', name: '黑色', checked: false},
    {color: '22,73,191', name: '深蓝', checked: false},
    {color: '255,255,255', name: '白色', checked: false},
  ],
  orientList: [
    {
      name: '横图',
      icon: "data:image/png;base64,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",
      w: 1024,
      h: 768,
    },
    {
      name: '竖图',
      icon: "data:image/png;base64,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",
      w: 768,
      h: 1024
    },
    {
      name: '方图',
      icon: "data:image/png;base64,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",
      w: 512,
      h: 512,
    },
  ],
  resultImgs: []
})
// 相似度
let similarity = ref(40)
// 生成数量
let createNum = ref(1)

let loading = ref(false)
// 图形大小索引
let orientCheckIndex = ref(0);
// 模组索引
let styleIndex = ref(0);
// 参考图
let orImg = ref('');
// 关键字promote
let keyWord = ref('');
let taskInfo: any = null;

let libraryRef = ref(null)
let materialLibraryVisible = ref(false)

const initParams = () => {
  orImg.value = ''
  keyWord.value = ''
  createNum.value = 1;
  orientCheckIndex.value = 0;
  styleIndex.value = 0;
  similarity.value = 40;
}
const getStyles = () => {
  service.get("/dwart/an_teaching/aibox/getModelStyles", {
    params: {
      scene: props.type
    }
  }).then((res: any) => {
    dataRef.tags = res.map(v => {
      return {
        ...v,
        checked: false
      }
    })
  })
}

const getTaskStatus = (coreObject) => {
  // 获取任务结果
  if (coreObject.status === 1) {
    clearInterval(timeout)
    dataRef.resultImgs = coreObject.urls;
    loading.value = false
  } else {
    setTimeout(() => {
      service.get("/dwart/an_teaching/aibox/getDrawStatus", {
        params: {
          name: coreObject.coreName,
          taskId: coreObject.taskId
        }
      }).then(res => {
        getTaskStatus(res)
      })
    }, 3 * 1000)
  }
};
const onCreateImg = () => {
  console.log('submit');
  if (props.type === 0 && !keyWord.value) {
    message.warn('请输入关键词')
    return
  }
  if (props.type !== 0 && !orImg.value) {
    message.warn('请选择参考图')
    return;
  }
  loading.value = true
  let checkColorName = dataRef.colorList.filter(v => v.checked).map(v => v.name)
  let checkSize = dataRef.orientList[orientCheckIndex.value]
  service.post("/dwart/an_teaching/aibox/drawImage", {
    processModel: props.type === 0 ? 1 : 2,
    prompt: keyWord.value + checkColorName.join(','),
    negativePrompt: null,
    orgImageUrl: orImg.value,
    seed: null,
    num: createNum.value,
    width: checkSize.w,
    height: checkSize.h,
    cfgScale: null,
    redrawScale: similarity.value / 100,
    loraCode: dataRef.tags[styleIndex.value]?.code,
    scene: props.type
  }).then(res => {
    if (!res) {
      return
    }
    if (res.status === 0) {
      message.success('任务提交成功，请耐心等待', 2)
      taskInfo = res;
      getTaskStatus(res)
    } else {
      message.error(res.msg, 2)
      loading.value = false;
    }
  })
}

const initSwiper = () => {
  swiperItem = new Swiper('#rt-swiper', {
    autoplay: false,//可选选项，自动滑动
    slidesPerView: 1,
    pagination: {
      el: '.swiper-pagination',
      type: 'fraction',
      clickable: true,
    },
  })
}
const onSaveImgs = () => {
  message.loading({
    content: '保存中...',
    key: 111,
    duration: 0,
  })
  service.post("/dwart/an_teaching/aibox//saveAIGenImages", {
    taskId: taskInfo.taskId,
    imgs: dataRef.resultImgs,
  }).then(res => {
    if (res) {
      message.success('保存成功', 1)
    } else {
      message.error('保存失败', 1)
    }
  }).finally(() => {
    message.destroy(111)
  })

}

const handleOk = (e) => {
  let {sourceUrl} = libraryRef.value?.confirmChoose();
  console.log(sourceUrl);
  orImg.value = sourceUrl;
  materialLibraryVisible.value = false;
}

const onOpenChooseImg = () => {
  materialLibraryVisible.value = true;
  nextTick(() => {
    libraryRef.value?.onInit();
  })
}

watch(() => props.type, () => {
  initParams();
  getStyles()
  initSwiper()
})



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _withDirectives(_createVNode(_unref(ATextArea), {
          value: _unref(keyWord),
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => (_isRef(keyWord) ? (keyWord).value = $event : keyWord = $event)),
          placeholder: "请输入关键词文字",
          allowClear: "",
          autosize: {minRows: 4, maxRows: 4}
        }, null, 8, ["value"]), [
          [_vShow, __props.type !== 4]
        ]),
        _createElementVNode("div", _hoisted_4, [
          _cache[5] || (_cache[5] = _createElementVNode("div", { class: "lt-label" }, "选择图片", -1)),
          _withDirectives(_createElementVNode("div", {
            class: "lt-chooseimg",
            onClick: onOpenChooseImg
          }, _cache[4] || (_cache[4] = [
            _createElementVNode("img", {
              src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAkCAYAAADy19hsAAAAAXNSR0IArs4c6QAABDFJREFUWEftmG1oW1UYx//PuUlfFP2gRZO0A7Hth6mIbx9ExA+K4LsyKMMuty9bTZrEFvtFEOYIY1J0g6EuSVdrk/amiEUR3JjC2JBNkTEGIg6ZVpzY3gQ7nTDsi733PCOpSW+7NMmymqawfArn9Xf+93+e55xD0Y47ambMf/cQy1YGnKiQHxHOM0TEPzq1l4g4g0Uh1fkumHsrhPMKDAHR44vrB7LAYbdzmsF1lQoMwrcBLfnIksJuR1buatiau+KTE+sNH25zPM0SR9IchImAlmy+DryWX6ViFA63u15gU/YS0f3MuATwKaoSu/zD+jnrgisCOKw69zPza1d8CaJ5gFoCmn4oU7fuwOH2+mfZNA+vahuiP2ttvHl7NDmdarP+wKpzjJlbF3c9HRW4wa0oc64Fw/wSwO3pYkGqfzQRrwjgkNt5BuAHUjBCUbb6RqbGU/9DqiMKRke6nOgtn5bYWRHA4SIUFiC3L54YqwzgjebhtGobKUpkosNAm+tFU8qe/z0Oh1TnFjBeBlgqCoW6RxIn1jKzrRyr5LAW6nRtIkOGmfFc9vABMEPs8Td5ghQMykLgH3TVN7CBOk9s6rtCbUtOHMxMkbZ6PyD7mXHTKhMdE3Rjq0/75Y9c9Qc9rjpjhgcJ/BKnoi/Rj6xweyCWPF0I/KoUnifTTsAQM2fPoIvxnjQwNzPwsGVC3UZiq1fTv7ZCDLhdT0rIkZU3GCIsEMSu7kbPO/m+TtHABBoC0MbgqiwA4VeFhbc7rh896HnQbszq+1bcUAwAbwTiyX3jwbuqLkxc7Ae4L6Vq1kaEBWbYLbb6yl6jqK8MTU3mUjui1j8u2Ty2mBlxNqAl78n2DVkO8NbOBJhM9J6tlnZ6B/UZa11YdbQA+NBqFyIcYqZNAN+3tFj6m8AeYcNZaeAjZty7tAj6ixgeXzzx6Uro9D3TmDtMwEOA6PPH9WheYCJ8zwq68vltoKOhWZrGJ1aI5RPTCdjJHYjqv6fKj/Q0Vf928Z+3GdxrVV8I2uIbTXxWyNe5gYnmibBbqXHt9Q6eWSg0yHhfQ+30BSOcOQ/8194AUdDf6O3P5dMBt/MpExzLHHpAGA5oyR2F5soJTDZ6zB9LnCy2c6ZdpM21XUo+QMS6Ats2rzZ5Kt8YEbXxNonZ1wF5a1W18uZqXs41Blk9fC2X0JDq3Fxjv3lyx/C5S1e74GX7w+3qBOR+EJ2uVaqf74ydn1u2t9YK+FogrX1DquMHMO5OlQlSnvBpU8crHfhnMJrSEU3gGf9o8ovrwKXaYXy8RZn+/OQ2CHFnNgow9zDzLYtJg8ZAlH7YIYlZslV9vGabrhToiNv1qoR8v+i+RD9R2d7WCJJAx607vyTgcr9eCkU86hvRv0mpWpIlyvY+nEPhXFYIqY78UaJo/5Sp4UYEzp84yiRc0dOEC6Tmy0GtwXmyE76iAAAAAElFTkSuQmCC",
              alt: ""
            }, null, -1),
            _createElementVNode("span", null, "选择素材库图片", -1)
          ]), 512), [
            [_vShow, !_unref(orImg)]
          ]),
          _withDirectives(_createElementVNode("div", {
            style: {"cursor":"pointer"},
            onClick: onOpenChooseImg
          }, [
            _createElementVNode("img", {
              src: _unref(orImg),
              alt: "",
              style: {"width":"120px","border":"5px solid #FF9900","border-radius":"5px"}
            }, null, 8, _hoisted_5)
          ], 512), [
            [_vShow, _unref(orImg)]
          ])
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_6, [
          _cache[6] || (_cache[6] = _createElementVNode("div", { class: "lt-label" }, "画面相似度", -1)),
          _createVNode(_unref(ASlider), {
            value: _unref(similarity),
            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (_isRef(similarity) ? (similarity).value = $event : similarity = $event)),
            marks: marks,
            style: {"flex":"1"}
          }, null, 8, ["value"])
        ], 512), [
          [_vShow, __props.type !== 4]
        ]),
        _createElementVNode("div", _hoisted_7, [
          _cache[7] || (_cache[7] = _createElementVNode("div", { class: "lt-label" }, "图片风格", -1)),
          _createVNode(_unref(ASpace), {
            size: [0, 8],
            wrap: ""
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_8, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(dataRef).tags, (i, key) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass(["tag-item", {'checked': _unref(styleIndex) === key}]),
                    key: key,
                    onClick: ($event: any) => (_isRef(styleIndex) //@ts-ignore
 ? styleIndex.value = key : styleIndex = key)
                  }, _toDisplayString(i.name), 11, _hoisted_9))
                }), 128))
              ])
            ]),
            _: 1
          })
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_10, [
          _cache[8] || (_cache[8] = _createElementVNode("div", { class: "lt-label" }, "颜色选择", -1)),
          _createElementVNode("div", _hoisted_11, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(dataRef).colorList, (item, key) => {
              return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["color-item", {'checked': item.checked}]),
                key: key,
                style: _normalizeStyle(`--color-item-bg: ${item.color}`),
                onClick: ($event: any) => (item.checked = !item.checked),
                title: item.name
              }, null, 14, _hoisted_12))
            }), 128))
          ])
        ], 512), [
          [_vShow, __props.type !== 4]
        ]),
        _createElementVNode("div", _hoisted_13, [
          _cache[9] || (_cache[9] = _createElementVNode("div", { class: "lt-label" }, "生成数量", -1)),
          _createElementVNode("div", null, [
            _createVNode(_unref(AInputNumber), {
              value: _unref(createNum),
              "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => (_isRef(createNum) ? (createNum).value = $event : createNum = $event)),
              min: 1,
              max: 4,
              size: "large"
            }, null, 8, ["value"])
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _cache[10] || (_cache[10] = _createElementVNode("div", { class: "lt-label" }, "图片方向", -1)),
          _createElementVNode("div", _hoisted_15, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(dataRef).orientList, (i, k) => {
              return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["orient-item", {'checked': _unref(orientCheckIndex) === k}]),
                key: k,
                onClick: ($event: any) => (_isRef(orientCheckIndex) //@ts-ignore
 ? orientCheckIndex.value = k : orientCheckIndex = k)
              }, [
                _createElementVNode("img", {
                  src: i.icon,
                  alt: ""
                }, null, 8, _hoisted_17)
              ], 10, _hoisted_16))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createVNode(_unref(AButton), {
            type: "primary",
            block: "",
            style: {"background":"#FEB528"},
            size: "large",
            loading: _unref(loading),
            onClick: onCreateImg
          }, {
            default: _withCtx(() => _cache[11] || (_cache[11] = [
              _createTextVNode("生成图片 ")
            ])),
            _: 1
          }, 8, ["loading"])
        ])
      ])
    ]),
    _cache[15] || (_cache[15] = _createStaticVNode("<div class=\"ct\" data-v-2d94a15b><div data-v-2d94a15b><div class=\"le le1\" data-v-2d94a15b><div class=\"le-l\" data-v-2d94a15b></div><div class=\"rto rto-1\" data-v-2d94a15b></div><div class=\"rto rto-2\" data-v-2d94a15b></div></div></div><div data-v-2d94a15b><div class=\"le le2\" data-v-2d94a15b><div class=\"le-l\" data-v-2d94a15b></div><div class=\"rto rto-1\" data-v-2d94a15b></div><div class=\"rto rto-2\" data-v-2d94a15b></div></div></div></div>", 1)),
    _createElementVNode("div", _hoisted_19, [
      _createVNode(_Transition, {
        "enter-active-class": "animate__animated animate__fadeIn",
        "leave-active-class": "animate__animated animate__fadeOut"
      }, {
        default: _withCtx(() => [
          _withDirectives(_createElementVNode("div", _hoisted_20, [
            _createElementVNode("img", {
              src: _imports_0,
              alt: "",
              class: _normalizeClass({'spin': _unref(loading)})
            }, null, 2),
            _cache[12] || (_cache[12] = _createElementVNode("div", { class: "loading-text" }, "等待生成图片", -1))
          ], 512), [
            [_vShow, _unref(loading)]
          ])
        ]),
        _: 1
      }),
      _withDirectives(_createElementVNode("div", _hoisted_21, [
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(dataRef).resultImgs, (i, k) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "swiper-slide",
                key: k
              }, [
                _createElementVNode("img", {
                  src: i,
                  alt: "",
                  style: {"width":"952px","height":"800px","border-radius":"30px","object-fit":"cover"}
                }, null, 8, _hoisted_24)
              ]))
            }), 128))
          ]),
          _cache[13] || (_cache[13] = _createElementVNode("div", { class: "swiper-pagination" }, null, -1))
        ]),
        _createElementVNode("div", {
          class: "save-icon",
          onClick: onSaveImgs
        }, _cache[14] || (_cache[14] = [
          _createElementVNode("img", {
            src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAgCAYAAAAFQMh/AAAAAXNSR0IArs4c6QAAAllJREFUWEftlz9o1HAUx7/fFP9URaz25HK6lDq7qlAUuqiDistxYoKIIOQO1EKhglDEOiioR5FcCw565lBRR4cuDuKi4uLiJCJUmqAoRYSTlsuTRK/Vu7SX36Xiclky5L33yfu+9/uS8OHQ9u4vn/1rQsmJyGaQUwXHPQgAtpGW4N7qKlQ8hvGmfoGCoxt71g8aN999Wy6PJVMvisi5haCEYIhcJvi8N9W1P1v8WF0KTttMuxCkVxIc1iKnUv09R7IX385Fwdkk5wp0vAji49ThgVw2+6jWCP/HYIAabltl9xTJv/ZFGUziCcE3vshZABuCTv5crmDGjd1p4LhVcRf3KJiEitQkp3sPDfQF0pWMzIjAvxIH/OtFtLFCZWa0/lJqYOBFvuLtCZInzEzOF/9+fDCgEcOW410Pd0+lYxAvC463O0icPJE5Vqv591TAYd/kactxbymCObuua03fyTsfZm1TH4fIGVUwCF+DdlwNHB5PTgN4LyL76vNqtVxNR4mYVwZHmYEqOHLGJF7lHW9X8LBk6lURWbus55I/8o7b/durb0BkqJW3Ry8XWE3t6NkUWJ1tZC4RMiKQ1ZG2B84JeLV+TGxDfwbI3jbBgKZh1LrrjcUpUI+ZMLcN+lJ7GjenecbhAmEe5HmrPFNstLqowpOGfsCnlEWwNRF4wV2ITwK+hsj36IJcRcpOEfTHBS7tXKoV2oyPlLrNWkppHbCSXEmCO1InUU8ptyO1klxJgv+j1I2/MEnaiJtLeLRNPfZXQ9y6LePIIpt+U1tmtR9A8iuFD7aktOGfWiVm9bM7wmkAAAAASUVORK5CYII=",
            alt: ""
          }, null, -1),
          _createElementVNode("span", null, "保存至素材库", -1)
        ]))
      ], 512), [
        [_vShow, !_unref(loading)]
      ])
    ]),
    _createVNode(_unref(AModal), {
      visible: _unref(materialLibraryVisible),
      "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => (_isRef(materialLibraryVisible) ? (materialLibraryVisible).value = $event : materialLibraryVisible = $event)),
      maskClosable: false,
      title: "素材图片",
      width: "90%",
      onOk: handleOk
    }, {
      default: _withCtx(() => [
        _createVNode(MaterialLibrary, {
          ref_key: "libraryRef",
          ref: libraryRef
        }, null, 512)
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}
}

})